var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-background-overlay",style:({
    opacity: _vm.opacity,
    pointerEvents: _vm.opacity > 1 ? 'auto' : 'none'
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }